import React, { useEffect } from "react";
import { BiEditAlt, BiPlus, BiTrashAlt, BiXCircle } from "react-icons/bi";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Popover,
  PopoverBody,
  PopoverHeader,
} from "reactstrap";
import { createMentionUrl, profilePicValidityCheck } from "../../../utils/constants";
import moment from "moment";
import { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { BsThreeDotsVertical } from "react-icons/bs";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import { Mention, MentionsInput } from "react-mentions";
import defaultMentionStyle from "../../stories/defaultMentionStyle";
import { isIphone, isMobile } from "../../../utils/deviceInfo";
import defaultMobileCreateStory from "../../stories/defaultMobileCreateStory";
import defaultCreateStory from "../../stories/defaultCreateStory";
import { marked } from "marked";
import parse from "html-react-parser";
import { orderBy } from "lodash";

function TriviaCommentsComponent({
  target,
  setCommentsPopoverOpen,
  commentsPopoverOpen,
  comments = [],
  setComments,
  user,
  triviaId,
  questionId,
  getCommentPageNumber,
  goToClickedPage
}) {

  comments = comments && Array.isArray(comments) ? orderBy(comments,(itm)=> itm.createdOn,["desc"]) : comments
  const [inputText, setInputText] = useState("");
  const [mentionsData, setMentionsData] = useState({plainTextMentions:"",mentions:[]});
  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  useEffect(() => {
    if (comments.length && questionId != "ALL") {
    } else {
      axios
        .post(url.getTrivvyComments, { triviaId, questionId })
        .then((data) => {
          const docs = data.data.data;
          setComments(docs);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const [editData, setEditData] = useState(null);

  const [editTextId, setEditTextId] = useState({
    id: null,
    text: null,
    plainText:null,
    mentions:[]
  });

  const goToProfile = () => {};

  const addComment = () => {
    axios
      .post(url.createTrivvyComment, {
        organizationId: user.profile.organizationId._id,
        createdBy: user.profile._id,
        triviaId,
        questionId,
        createdOn: new Date(),
        text: inputText,
        plainText:mentionsData.plainTextMentions,
        mentions:mentionsData.mentions
      })
      .then((data) => {
        const comments_arr = [...comments];
        const doc = data.data.data;
        setComments([doc, ...comments_arr]);
        setInputText("");
        setMentionsData({plainTextMentions:"",mentions:[]})
      })
      .catch((err) => {
        toastContainer("Error while adding comment", "error");
      });
  };

  const handleEditClick = (data) => {
    setEditTextId({
      id: data._id,
      text: data.text,
    });
    setEditData(null);
  };

  const editComment = () => {
    axios
      .post(url.updateTrivvyComment, {
        id: editTextId.id,
        data: {
          updatedOn: new Date(),
          text: editTextId.text,
          plainText:editTextId.plainText,
          mentions:editTextId.mentions
        },
      })
      .then((data) => {
        const comments_arr = [...comments];
        const doc = data.data.data;
        const currentIndex = comments_arr.findIndex(
          (x) => x._id === editTextId.id
        );

        if (currentIndex >= 0) {
          comments_arr[currentIndex] = doc;
          setComments(comments_arr);
          setEditTextId({
            id: null,
            text: "",
          });
          setEditData(null);
        }
      })
      .catch((err) => {
        toastContainer("Error while updating comment", "error");
      });
  };

  const handleDeleteClick = (itemId) => {
    axios
      .post(url.updateTrivvyComment, {
        id: itemId,
        data: {
          isDeleted: true,
          updatedOn: new Date(),
        },
      })
      .then((data) => {
        const comments_arr = [...comments];
        const filtered = comments_arr.filter((x) => x._id != itemId);
        setComments(filtered);
      })
      .catch((err) => {
        toastContainer("Error while deleting comment", "error");
      });
  };

  const fetchUsers = (query, callback) => {
    if (!query) return;

    axios
      .get(url.findUser(query))
      .then((resp, idx) =>
        resp.data.data.map((user) => ({
          id: user._id,
          display: `${user.firstName} ${user.lastName}`,
        }))
      )
      .then(callback);
  };

  const handleChangeCommentDescription = (
    event,
    newValue,
    newPlainTextValue,
    mentions
  ) => {
    setInputText(newValue);
    setMentionsData({
      plainTextMentions: createMentionUrl(newValue,user.profile)  ,
      mentions: mentions,
    });
  };

  const createMarkDown = (input) => {
    let string = input;

    let length = input
      .replace(/<a [\s\S]*?<\/a>/g, "")
      .replace(/<\/?[^>]+(>|$)/g, "").length;
    let start = 0;
    let end = 500;
    if (length > 500) {
      let mlength = input.replace(/<\/?[^>]+(>|$)/g, "").length;
      let oLength = input.length;
      let totalLength = oLength - mlength + end;
      // console.log('length--', totalLength, mlength, length)
      string = input.slice(start, totalLength)+"...";
    } else {
      string = input;
    }

    let m_down = marked.parse(string, {
      breaks: true,
    });

    return m_down;
  };

  const renderAsHtml = (text) => {
    return parse(createMarkDown(text));
  };

  return (
    <Popover
      hideArrow
      isOpen={commentsPopoverOpen}
      placement="right"
      target={target}
      toggle={() => setCommentsPopoverOpen(!commentsPopoverOpen)}
      className="trivvy_question_comment_popover"
      
    >
      <PopoverBody className="trivvy_question_comment_popover_body">
        <div className="d-flex justify-content-between align-items-center">
          Comments{" "}
          <BiXCircle
            cursor="pointer"
            onClick={() => setCommentsPopoverOpen(!commentsPopoverOpen)}
          />
        </div>
        <hr />
        <div className="trivvy-question-comments-view">
          {comments && Array.isArray(comments) && comments.length
            ? comments.map((item) => {
                return (
                  <div className="my-1 comment-item-trivvy">
                    <div className="d-flex my-0 py-0">
                      <span className="mt-1">
                        {profilePicValidityCheck(item.createdBy.profilePic) ? (
                          <img
                            src={item.createdBy.profilePic}
                            className="spotlightImage"
                            alt=""
                            onClick={goToProfile}
                          />
                        ) : (
                          <span
                            className="spotlightUserInitials mr-1"
                            onClick={goToProfile}
                            data-letters={getInitials(item.createdBy)}
                          />
                        )}
                      </span>

                      <div className="ml-1">
                        <div className="font-13px">
                          {item.createdBy
                            ? `${item.createdBy.firstName || ""} ${item
                                .createdBy.lastName || ""}`
                            : "User"}
                        </div>
                        <div className="survey-createddate-text">
                          {moment(item.createdOn).format(
                            "h:mma on MMM D, YYYY"
                          )}
                          {questionId == "ALL" && getCommentPageNumber ? (
                            <span className="cursor-pointer text-info" onClick={()=>{
                              goToClickedPage(item.questionId)
                            }}>(Page #{getCommentPageNumber(item)})</span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {item.createdBy &&
                      item.createdBy._id === user.profile._id ? (
                        <div style={{ marginLeft: "auto" }}>
                          <Dropdown
                            className="mr-2"
                            isOpen={editData && editData._id == item._id}
                            toggle={() =>
                              editData && editData._id
                                ? setEditData(null)
                                : setEditData(item)
                            }
                          >
                            <DropdownToggle
                              tag="span"
                              className="cursor-pointer"
                            >
                              <BsThreeDotsVertical />
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem
                                onClick={() => handleEditClick(item)}
                              >
                                Edit <BiEditAlt className="ml-1" />
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => handleDeleteClick(item._id)}
                              >
                                Delete <BiTrashAlt className="ml-1" />
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="pl-2 mt-1">
                      {editTextId &&
                      editTextId.id &&
                      editTextId.id == item._id ? (
                        <div>
                          {/* <Input
                            value={editTextId.text}
                            onChange={(e) =>
                              setEditTextId({
                                ...editTextId,
                                text: e.target.value,
                              })
                            }
                            type="textarea"
                            className="trivvy_question_comment_input"
                            placeholder="Enter comment here ..."
                          /> */}
                          <div style={{ width: "250px" }}>
                            <MentionsInput
                              autoFocus
                              style={
                                isMobile
                                  ? defaultMobileCreateStory
                                  : defaultCreateStory
                              }
                              value={editTextId.text}
                              onChange={(event,
                                newValue,
                                newPlainTextValue,
                                mentions)=>{
                                  setEditTextId({
                                    ...editTextId,
                                    text: newValue,
                                    plainText:  createMentionUrl(newPlainTextValue),
                                    mentions:mentions
                                  })
                              }}
                              markup="@{{__type__||__id__||__display__}}"
                              placeholder={"Add comment"}
                              singleLine={false}
                            >
                              <Mention
                                autoFocus
                                type="user"
                                trigger="@"
                                style={defaultMentionStyle}
                                data={fetchUsers}
                                className="mentions_mention_trivvy_comments"
                              />
                            </MentionsInput>
                          </div>

                          <Button
                            onClick={editComment}
                            className="ml-1 mt-1"
                            color="info"
                            size="sm"
                          >
                            Save
                          </Button>
                          <Button
                            onClick={() => {
                              setEditTextId({ id: null, text: null });
                              setEditData(null);
                            }}
                            className="ml-2 mt-1"
                            color="danger"
                            size="sm"
                          >
                            Cancel
                          </Button>
                        </div>
                      ) : (
                        <span>{ item.plainText && item.plainText.length ? renderAsHtml(item.plainText) : item.text}</span> 
                      )}
                    </div>
                    <hr />
                  </div>
                );
              })
            : "No comments"}
        </div>
        {questionId != "ALL" ? (
          <div className="trivvy-question-comments-add p-2">
            {/* <Input
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              type="textarea"
              className="trivvy_question_comment_input"
              placeholder="Enter comment here ..."
            /> */}

            <div style={{ width: "300px" }}>
              <MentionsInput
                autoFocus
                style={isMobile ? defaultMobileCreateStory : defaultCreateStory}
                value={inputText}
                onChange={handleChangeCommentDescription}
                markup="@{{__type__||__id__||__display__}}"
                placeholder={"Add comment"}
                singleLine={false}
              >
                <Mention
                  autoFocus
                  type="user"
                  trigger="@"
                  style={defaultMentionStyle}
                  data={fetchUsers}
                  className="mentions_mention_trivvy_comments"
                />
              </MentionsInput>
            </div>

            {inputText && inputText.trim().length ? (
              <span
                className="trivvy_question_comment_add_button ml-2"
                onClick={addComment}
              >
                <BiPlus size={20} />
              </span>
            ) : (
              <span className="trivvy_question_comment_add_button_disabled cursor-default ml-2">
                <BiPlus size={20} />
              </span>
            )}
          </div>
        ) : (
          <div style={{ width: "350px" }}></div>
        )}
      </PopoverBody>
    </Popover>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TriviaCommentsComponent));
